module.exports = __webpack_public_path__ + "static/media/sim-card.3c7cc25c.svg";